import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const buildVersion = process.env.REACT_APP_BUILD_ID;

// We need to check value of "PUBLIC_URL" variable to specify the locales path because,
// in the real environments, the additionals app is not in the root path of the domain,
// but in an "/additionals" subpath.
const localesLoadPath = process.env.PUBLIC_URL
  ? `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
  : "/locales/{{lng}}/{{ns}}.json";

// Initialize instance of i18n
i18n
  .use(detector)
  .use(backend)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "nl"],
    // Append version query param to i18next requests so it works properly with caching
    // @see https://infinitas-chat.slack.com/archives/C028MSNU9NH/p1739267845554969
    backend: {
      loadPath: buildVersion ? `${localesLoadPath}?version=${buildVersion}` : localesLoadPath,
    },
    fallbackLng: "en", // Default language in our case
    ns: ["toast"],
    debug: true,
    react: {
      useSuspense: true,
    },
  });

export default i18n;
